<template>
	<router-link :to="to" class="btn">
		<slot></slot>
		<icon v-if="icon" :icon="icon"></icon>
	</router-link>
</template>

<script>
	export default {
		props: ['icon', 'to']
	}
</script>